document.addEventListener('DOMContentLoaded', function () {
  // Current hour (0-23) in Colombia (America/Bogota), independent of the
  // visitor's own timezone.
  function bogotaHour() {
    try {
      var formatted = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Bogota',
        hour: '2-digit',
        hour12: false,
        hourCycle: 'h23',
      }).format(new Date());
      return parseInt(formatted, 10);
    } catch (e) {
      return new Date().getHours();
    }
  }

  // Financing is unavailable from 8:00 p.m. (20) up to 8:00 a.m. (8).
  function isFinancingClosed() {
    var hour = bogotaHour();
    return hour >= 20 || hour < 8;
  }

  function refreshRestricted(dialog) {
    var closed = isFinancingClosed();
    dialog.querySelectorAll('[data-financing-time-restricted]').forEach(function (button) {
      button.classList.toggle('is-disabled', closed);
      button.setAttribute('aria-disabled', closed ? 'true' : 'false');
    });
    var notice = dialog.querySelector('[data-financing-closed]');
    if (notice) notice.hidden = !closed;
  }

  document.querySelectorAll('[data-financing-open]').forEach(function (opener) {
    var id = opener.getAttribute('data-financing-open');
    var dialog = document.querySelector('[data-financing-dialog="' + id + '"]');
    if (!dialog) return;

    opener.addEventListener('click', function () {
      refreshRestricted(dialog);
      dialog.showModal();
    });

    dialog.querySelectorAll('[data-financing-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        dialog.close();
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    // Block the redirect while financing is closed.
    dialog.querySelectorAll('[data-financing-time-restricted]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        if (isFinancingClosed()) {
          event.preventDefault();
          refreshRestricted(dialog);
        }
      });
    });
  });
});
